(function($) {
$(function(){

  /*****
    Set some global variables
  *****/
  var template_url = $('#template_url').val();


  if ($('.rellax').length) {
    var rellax = new Rellax('.rellax', {
      speed: 7,
      center: true
    });
  }


  /*****
    Side nav
  *****/
  $('.site-nav-open').on('click', function(e){
    e.preventDefault();
    $('html').toggleClass('nav-state-closed').toggleClass('nav-state-open');
  });

  $('.site-nav-cover, .site-nav-close').on('click', function(){
    $('html').addClass('nav-state-closed').removeClass('nav-state-open');
  });

  $('.site-header-nav li.menu-item-has-children > a').append('<svg data-icon="arrow_down" viewBox="0 0 22 13"><use xlink:href="#arrow_down"></use></svg>');

  $('.site-header-nav li.menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $('.menu-children-shown > a').not($(this)).click();
    $(this).parents('li').toggleClass('menu-children-shown');
    $(this).parents('li').find('ul').slideToggle(300);
  });

  $('.site-header-nav .current-menu-parent').each(function(){
    $(this).find('> a').click();
  });


  $(window).scroll($.throttle(100, function(){
    var scroll_pos = window.pageYOffset || document.documentElement.scrollTop;
    var scroll_pos_trigger_point = 600;
    if (scroll_pos > scroll_pos_trigger_point) {
      $('html').addClass('top-nav-fixed');
    } else {
      $('html').removeClass('top-nav-fixed');
    }
  }));


  // When BG image has loaded…
  $('[data-when-bg-loaded]').bgLoaded({
    afterLoaded : function(){
     this.addClass(this.attr('data-when-bg-loaded'));
    }
  });


  // Home page number animations
  if ($('.text-in-shape-inner').length) {

    var easingFn = function (t, b, c, d) {
      var ts = (t /= d) * t;
      var tc = ts * t;
      return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
    }

    var options = {
      useEasing : true,
      easingFn: easingFn,
      useGrouping : true,
      separator : ',',
      decimal : '.',
      prefix : '',
      suffix : ''
    };

    var to_1 = parseInt($('#number-counter-1').attr('data-count-to'));
    var number_counter_1 = new CountUp("number-counter-1", 0, to_1, 0, 2, options);
    var to_2 = parseInt($('#number-counter-2').attr('data-count-to'));
    var number_counter_2 = new CountUp("number-counter-2", 0, to_2, 0, 2.4, options);
    var to_3 = parseInt($('#number-counter-3').attr('data-count-to'));
    var number_counter_3 = new CountUp("number-counter-3", 0, to_3, 0, 2.8, options);

    $('.text-in-shape-inner').viewportChecker({
      offset: '50%',
      repeat: false,
      callbackFunction: function(elem, action){

        number_counter_2.start();
        number_counter_3.start();

        setTimeout(function(){
          $('.spending-figure-1').addClass('shown');
          number_counter_1.start();
        }, 300);

        setTimeout(function(){
          $('.spending-figure-2').addClass('shown');
          number_counter_2.start();
        }, 600);

        setTimeout(function(){
          $('.spending-figure-3').addClass('shown');
          number_counter_3.start();
        }, 900);
      }
    });
  }

  // Image & button joint hover effects
  if ($('.text-and-image-image').length) {
    $('.text-and-image-image').hover(function(){
      $(this).parents('.text-and-image').find('.button').addClass('active');
    }, function(){
      $(this).parents('.text-and-image').find('.button').removeClass('active');
    });

    $('.text-and-image .button').hover(function(){
      $(this).parents('.text-and-image').find('.text-and-image-image').addClass('hover');
    }, function(){
      $(this).parents('.text-and-image').find('.text-and-image-image').removeClass('hover');
    });
  }


  /*****
    AJAX Load More
  *****/
  if ($('.js-load-more').length) {
    


    if ($('.js-load-more').length) {
      $('.js-load-more').on('click', function(e){
        e.preventDefault();
  
        // Alias the button element
        var self = $(this);
  
        // Get the JSON data from thr button itself
        var data_json = (self.attr('data-data')) ? self.attr('data-data') : '';
        var load_data = JSON.parse(data_json);
  
        // Add the post count to the JSON array we got amove
        var post_count = $('' + load_data.single_class).length;
        load_data.post_count = post_count;
  
        // Change the button text to the loading text
        self.addClass('loading');
        self.find('span').html(load_data.loading_text);
  
        $.ajax({
          method: "GET",
          url: template_url + "/load-more.php",
          data: load_data,
          complete: function(){
            // console.log(this.url);
          }
        }).done(function(msg) {
          // console.log(msg);
          setTimeout(function(){
            $('' + load_data.container_class).append(msg);
            self.find('span').html(load_data.initial_text);
            self.removeClass('loading');
            if (load_data.total_posts == $('' + load_data.container_class + ' ' + load_data.single_class).length) {
              $('.js-load-more').remove();
            }
          }, 500);
        });
  
      });
    }//if ($('.js-load-more').length)

    $(window).scroll($.throttle(100, function(){
      if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {

        setTimeout(function(){
          $('.js-load-more[data-load-on-scroll="true"]').click();
          $('.js-load-more[data-load-on-scroll]').attr('data-load-on-scroll', false);
        }, 300);

        setTimeout(function(){
          $('.js-load-more[data-load-on-scroll]').attr('data-load-on-scroll', true);
        }, 800);
       }
    }));

  }//if ($('.js-load-more').length)


  function new_map($el) {
  	var $markers = $el.find('.marker');
  	var args = {
  		zoom : 15,
  		center : new google.maps.LatLng(0, 0),
  		mapTypeId	: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles : [{"featureType":"administrative.neighborhood","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"saturation":6},{"lightness":-31},{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"on"},{"hue":"#00ff8a"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"weight":"0.68"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"saturation":"0"},{"lightness":"0"},{"visibility":"simplified"},{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"hue":"#ff0000"},{"saturation":"-100"},{"lightness":13},{"visibility":"simplified"}]},{"featureType":"road.local","elementType":"all","stylers":[{"hue":"#ff0000"},{"saturation":"100"},{"lightness":100},{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"on"},{"color":"#000000"},{"saturation":"-85"},{"lightness":"70"},{"gamma":"0.53"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#0083ff"},{"saturation":38},{"lightness":-11},{"visibility":"on"}]}]
  	};
  	var map = new google.maps.Map($el[0], args);
  	map.markers = [];
  	$markers.each(function(){
      add_marker($(this), map);
  	});
  	center_map(map);
  	return map;
  }

  function add_marker($marker, map) {
  	var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
  	var marker = new google.maps.Marker({
  		position : latlng,
  		map : map,
      icon: '/wp-content/themes/MantisPR/src/svg/pin.svg'
  	});

  	map.markers.push(marker);
  }


  function center_map(map) {
  	var bounds = new google.maps.LatLngBounds();

  	$.each(map.markers, function(i, marker){
  		var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
  		bounds.extend(latlng);
  	});

  	if (map.markers.length == 1) {
	    map.setCenter(bounds.getCenter());
	    map.setZoom(15);
  	} else {
  		map.fitBounds(bounds);
  	}
  }

  if ($('.acf-map').length) {
    var map = null;
    $('.acf-map').each(function(){
      map = new_map($(this));
    });
  }


  if ($('.sector-quotes-inner-carousel').length) {
    var sector_quotes = $('.sector-quotes-inner-carousel').flickity({
      cellSelector: '.sector-quotes-inner-carousel-slide',
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: ($('.sector-quotes-inner-carousel-slide').length >= 2) ? true : false,
      wrapAround: true,
      groupCells: false,
      autoPlay: false
    });
    sector_quotes.flickity('resize');
  }
  

  

  
  if ($('.clients-case-studies-items').length) {
    var sector_quotes = $('.clients-case-studies-items').flickity({
      cellSelector: '.clients-case-studies-item',
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      autoPlay: false,
      adaptiveHeight: true
    });
    sector_quotes.flickity('resize');
  }



  if ($('.sector-clients-logos-chunks').length) {
    var carousel_per_page = parseInt($('.sector-clients-logos-chunks').attr('data-carousel-per-page'));

    var flickity_args = {
      cellSelector: '.sector-clients-logos',
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      groupCells: false
    };

    var sector_logos = $('.sector-clients-logos-chunks').flickity(flickity_args);
    sector_logos.flickity('resize');

    setTimeout(function(){
      sector_logos.flickity('resize');
    }, 300);
  }

  if (matchMedia && $('.sector-clients-logos-chunks').length) {
    var mq_min_700 = window.matchMedia("(min-width: 700px)");
    mq_min_700.addListener(logo_grid_chunks);
    logo_grid_chunks(mq_min_700);

    function logo_grid_chunks(mq) {
      if (mq.matches) {
        // Window is 700px or more

        if ($('.sector-clients-logos-chunks').hasClass('flickity-enabled')) {
          sector_logos.flickity('destroy');
        }

        $(".sector-clients-logos-chunks .sector-clients-logos .sector-clients-logo").unwrap();

        var chunks = $(".sector-clients-logos-chunks .sector-clients-logo");
        for (var i = 0; i < chunks.length; i+=carousel_per_page) {
          chunks.slice(i, i+carousel_per_page).wrapAll("<div class='sector-clients-logos'></div>");
        }
        flickity_args.pageDots = ($('.sector-clients-logo').length > carousel_per_page) ? true : false;
        sector_logos.flickity(flickity_args);

      } else {
        // Window is 699px or less

        if ($('.sector-clients-logos-chunks').hasClass('flickity-enabled')) {
          sector_logos.flickity('destroy');
        }

        $(".sector-clients-logos-chunks .sector-clients-logos .sector-clients-logo").unwrap();

        var chunks = $(".sector-clients-logos-chunks .sector-clients-logo");
        for (var i = 0; i < chunks.length; i+=1) {
          chunks.slice(i, i+1).wrapAll("<div class='sector-clients-logos'></div>");
        }
        flickity_args.pageDots = true;
        sector_logos.flickity(flickity_args);
      }
    }
  }




  if ($('.service-products-item-title').length) {
    $('.service-products-item-title').on('click', function(e){
      e.preventDefault();

      var other_opens = $('.service-products-item-title.open').not($(this));
      other_opens.removeClass('open');
      other_opens.parents('.service-products-item').find('.service-products-item-toggle').removeClass('open');
      other_opens.parents('.service-products-item').find('.service-products-item-content').slideUp(300);

      $(this).toggleClass('open');
      $(this).parents('.service-products-item').find('.service-products-item-toggle').toggleClass('open');
      $(this).parents('.service-products-item').find('.service-products-item-content').slideToggle(300);

      setTimeout(function(){
        if ($('.service-products-item-toggle.open').length) {
          var this_offset = $('.service-products-item-toggle.open').offset();
          var header_height = $('.top-nav').outerHeight();
          $('html, body').stop(true, false).animate({scrollTop: (this_offset.top - header_height - 10) }, 300);
        }
      }, 300);
    });
  }

  if ($('.text-and-image-inner-toggle').length) {
    console.log('allow toggle');
    $('.text-and-image-inner-toggle').on('click', function(e){
      console.log('do toggle');
      e.preventDefault();

      var self_button = $(this);
      var content = $(this).parents('.text-and-image').find('.text-and-image-inner-toggle-content');

      if (content.hasClass('clamped')) {
        self_button.html('Read less');
      } else {
        self_button.html('Read more');
      }

      content.toggleClass('clamped');
    });
  }

});
})(jQuery);
